import React, { FC } from 'react';
import styled from 'styled-components';
import { useDesignSystemVar } from '../../hooks/useDesignSystemVar';
import Echart from '../../../components/eChart/Echart';
import { parser } from './helpers/parser';
import { environment } from '../../../environments/environment';
import { useElementOnScreen } from './helpers/useElementOnScreen';

const environmentLink:string|undefined = environment().assetsLink;
const ChartStyled = styled.div<ChartStyledProps>`
  width: 100%;
  display: flex;
  justify-content: ${props => props.horizontalAlignment || 'inherit'};
  align-items: center;
  opacity: ${props => props.opacity !== 0 ? '1' : 0};
  transition: opacity .2s ease-in-out;
  overflow: hidden;
  .echarts-for-react  {
    width: 100%;
    max-width: ${props => props.width}%;
  }
`

type ChartProps = {
  width: string,
  horizontalAlignment: string,
  chartType: string,
  data: any,
  color: string,
  title: string,
  prefix: string,
  suffix: string,
  anchorTrigger: string,
  showLegend: boolean,
  showGridlines: boolean,
  showAnnotation: boolean,
  annotationPosition: string,
  showAxisLabels: boolean,
  legendPosition: string,
  lineSize: string,
  donut: boolean,
  smooth: boolean,
  height: number,
  animation: boolean
}

type ChartStyledProps = {
  width: string,
  horizontalAlignment: string,
  opacity: number
}

const Chart: FC<ChartProps> = ({ ...props }) => {
  const fontFamily: string|undefined = useDesignSystemVar('var(--title-font)');
  const option: {option: {[key: string]: unknown}} = parser(props.chartType, { ...props, fontFamily });
  const [ containerRef, key ] = useElementOnScreen({ threshold: .7 }, props.animation)

  return (
    <ChartStyled width={props.width} ref={containerRef} opacity={key} horizontalAlignment={props.horizontalAlignment}>
      <Echart option={option.option} trigger={key} height={props.height} />
    </ChartStyled>
  )
}

//element options
const options = [
    { 
      name:'data',
      title: 'Edit data',
      icon: environmentLink + '/assets/images/Options/edit-white.svg',
      action: 'setActiveSetting',
      settingTitle: 'Edit Data'
    },
    {
      name:'ChartLayout',
      title: 'Settings',
      icon: environmentLink + '/assets/images/Options/settings.svg',
      action: 'setActiveSetting',
      settingTitle: 'Layout'
    }
]

export default {
  Chart,
  options
};
